var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 1H2.99984C1.71117 1 0.666504 2.04467 0.666504 3.33333V12.6667C0.666504 13.9553 1.71117 15 2.99984 15H16.9998C18.2885 15 19.3332 13.9553 19.3332 12.6667V3.33333C19.3332 2.04467 18.2885 1 16.9998 1Z",
    stroke: "#034A73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 4.5L8.95684 8.64517C9.2807 8.807 9.63779 8.89125 9.99984 8.89125C10.3619 8.89125 10.719 8.807 11.0428 8.64517L19.3332 4.5",
    stroke: "#034A73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0c4ee26aaaca5c1c7b6b22285d211464.svg";
export { ForwardRef as ReactComponent };